import type { MediaTarget } from "../state/MediaSession";

export function returnToCall(target: MediaTarget | null, dmXid?: string) {
  const dm = dmXid ?? (target?.context === "dm" ? target.xid : undefined);
  if (dm) window.dispatchEvent(new CustomEvent("link:open-dm-xid", { detail: { dmXid: dm, focusCall: true } }));
  else if (target?.context === "space") window.dispatchEvent(new CustomEvent("link:open-space", { detail: { spaceXid: target.xid } }));
}
